import {Component, ViewChild} from '@angular/core';
import {Paginator} from "../../../../models/Paginator";
import {Vehicle} from "../../../../models/Vehicle";
import {BreadcrumbService} from "../../../../core/services/breadcrumb/breadcrumb.service";
import {StationService} from "../../../../core/services/stations/station.service";
import {VehiclesService} from "../../../../core/services/vehicles/vehicles.service";
import {ToastrService} from "ngx-toastr";
import {ActiveFilter} from "../../../../models/Table/ActiveFilter";
import {SortColumn} from "../../../../models/Table/SortColumn";
import {TableHeader} from "../../../../models/Table/TableHeader";
import {Filter} from "../../../../models/Table/Filter";
import {FuelService} from "../../../../core/services/fuels/fuel.service";
import {Fuel} from "../../../../models/Fuel";
import {GenericTableComponent} from "../../../../shared/components/generic-table/generic-table.component";
import {TableFiltersComponent} from "../../../../shared/components/generic-table/table-filters/table-filters.component";
import {
  TableHeaderWrapperComponent
} from "../../../../shared/components/generic-table/table-header-wrapper/table-header-wrapper.component";
import {FormErrorDirective} from "../../../../shared/directives/forms/form-error.directive";
import {FormInputDirective} from "../../../../shared/directives/forms/form-input.directive";
import {FormLabelDirective} from "../../../../shared/directives/forms/form-label.directive";
import {LoaderComponent} from "../../../../shared/components/loader/loader.component";
import {NgIf} from "@angular/common";
import {PaginatorModule} from "primeng/paginator";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {TableActions} from "../../../../models/Table/TableActions";
import {Service} from "../../../../models/Service";

@Component({
  selector: 'app-fuels',
  standalone: true,
    imports: [
        GenericTableComponent,
        TableFiltersComponent,
        TableHeaderWrapperComponent,
        FormErrorDirective,
        FormInputDirective,
        FormLabelDirective,
        LoaderComponent,
        NgIf,
        PaginatorModule,
        ReactiveFormsModule
    ],
  templateUrl: './fuels.component.html',
  styleUrl: './fuels.component.css'
})
export class FuelsComponent {

  editFuel?: {action: TableActions, item: Fuel, index: number} = undefined;
  editForm?: FormGroup;
  loadingEdit: boolean = false;

  @ViewChild('genericTableComponent') genericTableComponent!: GenericTableComponent<Fuel>;

  loading:boolean=false;
  fuels:Paginator<Fuel>| null = null;
  constructor(private breadcrumbService: BreadcrumbService, private fuelService:FuelService,
              private toastr: ToastrService, private fb: FormBuilder) {
    this.breadcrumbService.setBreadcrumb({
      display_name: 'Combustibles',
      items: [{
        name: 'Listado',
      }]
    });
  }

  ngOnInit() {
    this.loading=true;
    this.loadFuels();
  }

  loadFuels(){
    this.fuelService.listpPaginate().subscribe(
      {
        next: (response) => {
          if (response.data) {
            this.fuels = response.data;
          }
          this.loading = false;
        },
        error: err => {
          this.loading = false;
        }
      }
    );
  }

  perPage: number = 50;
  loadingList = false;
  loadingFilters = false;

  filters: ActiveFilter[] = [];
  sorts: SortColumn[] = [];

  tableHeaders: TableHeader[] = [
    {
      name: 'ID',
      active: true,
      td_type: 'text',
      td_key: 'id',
      sort: false,
    },
    {
      name: 'NOMBRE',
      active: true,
      td_type: 'text',
      td_key: 'name',
      sort: false,
    },
    {
      name: 'NOMBRE CATALÁN',
      active: true,
      td_type: 'text',
      td_key: 'name_cat',
      sort: false,
    },
    {
      name: 'SLUG',
      active: true,
      td_type: 'text',
      td_key: 'slug',
      sort: false,
    },
    {
      name: 'FECHA CREACIÓN',
      active: false,
      td_type: 'date',
      format:'dd/MM/Y HH:mm',
      td_key: 'created_at',
      sort: false,
    },
    {
      name: 'FECHA MODIFICACIÓN',
      active: false,
      td_type: 'date',
      format:'dd/MM/Y HH:mm',
      td_key: 'updated_at',
      sort: false,
    }
  ]

  tableFilters: Filter[] = [
    {
      key: 'name',
      type: 'search',
      operator: 'like',
      placeholder: 'Buscar...'
    }
  ]

  tableActions: TableActions[] = [
    {
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.25"  stroke-linecap="round"  stroke-linejoin="round"   class="w-8"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" /><path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" /><path d="M16 5l3 3" /></svg>',
      name: 'Editar',
      key: 'update',
      color: '#ff9900',
      confirm: false,
    }
  ];

  onChangeSorts(sorts: SortColumn[]): void {
    this.sorts = sorts;
    this.loadFuels();
  }

  onClickAction(data: {action: TableActions, item: Fuel, index: number}) {
    if (data.action.key == 'update') {
      this.setEditFuel(data);
    }
  }

  setEditFuel(data: {action: TableActions, item: Fuel, index: number}){
    this.editForm = this.fb.group({
      name: [data.item.name, Validators.required],
      name_cat: [data.item.name_cat,],
    });
    this.editFuel = data;
    //console.log(this.editFuel);
  }

  update(){
    if (this.editForm && this.editForm.valid && this.editFuel) {

      //console.log(this.editForm.value);
      //this.loadingEdit = true;

      this.loadingEdit = true;
      this.fuelService.update(this.editFuel.item.id, this.editForm.value).subscribe({
        next: data => {
          this.toastr.success('Combustible editado correctamente.');
          if (data.data && this.editFuel) {
            this.editFuel.item = data.data;
            this.setEditFuel(this.editFuel);
            this.genericTableComponent.setItemAt(this.editFuel.index, this.editFuel.item);
          }

          this.loadingEdit = false;
        },
        error: err => {
          this.toastr.error('Ha habido un error al editar el combustible.');
          this.loadingEdit = false;
        }
      })
    } else {
      this.editForm?.markAllAsTouched();
    }
  }

  closeEditModal(){
    this.editFuel = undefined;
    this.editForm = undefined;
    // this.newImage = undefined;
    // this.newImagePreviewUrl = undefined;
  }

  onChangeFilters(filters: ActiveFilter[]){
    this.filters = filters;
    this.loadFuels();
  }

}
